// The Android app's JS bridge (MainActivity addJavascriptInterface "CompassApp"), when running inside the app.
interface CompassApp {
  dial(phone: string): void;
  logout(): void;
  openExternal(url: string): void;
  deviceCheck(): void;
  syncNow(): void;
}
export const Native: CompassApp | null = (window as unknown as { CompassApp?: CompassApp }).CompassApp ?? null;
